import { render, staticRenderFns } from "./FeatureTile.vue?vue&type=template&id=0a603924&scoped=true"
import script from "./FeatureTile.vue?vue&type=script&lang=js"
export * from "./FeatureTile.vue?vue&type=script&lang=js"
import style0 from "./FeatureTile.vue?vue&type=style&index=0&id=0a603924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a603924",
  null
  
)

export default component.exports